/**
 * The words StarScribe's shell puts around a page (docs/CONTRACT-starscribe-clients.md, mockup pictures 31, 33, 34, 41 and
 * 54): how long ago a page changed, when a deleted page is erased, and a page's short title for the narrow "Chat | <title>"
 * tabs. Dates are the person's own (the runtime's time zone), in the mockups' English.
 */
const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
function startOfDay(ms) {
    const day = new Date(ms);
    day.setHours(0, 0, 0, 0);
    return day.getTime();
}
/**
 * How long ago: "just now", "2 min ago", "3 h ago" (earlier today), "yesterday", the weekday within the last week
 * ("Monday"), else the date ("Oct 14", with the year when it is another year's).
 */
export function pageAge(atMs, nowMs) {
    const since = nowMs - atMs;
    if (since < MINUTE)
        return 'just now';
    if (since < HOUR)
        return `${Math.floor(since / MINUTE)} min ago`;
    const days = Math.round((startOfDay(nowMs) - startOfDay(atMs)) / DAY);
    if (days <= 0)
        return `${Math.floor(since / HOUR)} h ago`;
    if (days === 1)
        return 'yesterday';
    const when = new Date(atMs);
    if (days < 7)
        return when.toLocaleDateString('en-US', { weekday: 'long' });
    return when.getFullYear() === new Date(nowMs).getFullYear()
        ? when.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
        : when.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
/** A Recently deleted row's line (picture 54): "deleted 3 days ago · erased in 27 days". */
export function deletedLine(deletedAtMs, purgeAtMs, nowMs) {
    const ago = Math.max(0, Math.floor((nowMs - deletedAtMs) / DAY));
    const left = Math.max(0, Math.ceil((purgeAtMs - nowMs) / DAY));
    const deleted = ago === 0 ? 'deleted today' : ago === 1 ? 'deleted 1 day ago' : `deleted ${ago} days ago`;
    const erased = left === 0 ? 'erased today' : left === 1 ? 'erased in 1 day' : `erased in ${left} days`;
    return `${deleted} · ${erased}`;
}
/** The page's title up to its first comma, colon or dash ("Scope letter, Northgate" is "Scope letter"), at most 24 characters. */
export function shortPageTitle(title) {
    const whole = title.trim();
    const head = whole.split(/,|:| [-–—] /)[0].trim() || whole;
    if (!head)
        return 'Page';
    return head.length > 24 ? `${head.slice(0, 23).trimEnd()}…` : head;
}
//# sourceMappingURL=words.js.map